// ====================================================================================
// tabs.module
// ====================================================================================
import $ from "jquery";

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      $('section [role="tab"]').on("click", function () {
        $(this).parent().parent().find("button.active").removeClass("active");
        $(this).addClass("active");

        const tabsContainer = $(this).closest('[role="tablist"]').next();
        const tabId = this.getAttribute("aria-controls");
        const tabsActivePrev = tabsContainer
          .find(".tab-pane.show")
          .not(`[data-target="${tabId}"]`);
        const tabsActiveNext = tabsContainer.find(`.tab-pane[id="${tabId}"]`);

        tabsActivePrev.removeClass("show").removeClass("active");
        tabsActiveNext.addClass("active").addClass("show");
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
